import { DailyTripExpense } from "./dailyTripExpense";
import { DateHelper } from "../../helpers/DateHelper";

export class DailyTrip{
    id: number;
    tripDate: string;
    vehicleId: number;

    driverId: number;
    helperId: number;
    bookKeeperId: number;
    tripId: number;
    tripContainerDetailId: number;
    
    dailyTripExpenses: DailyTripExpense[];
    createdDate: string;
    createdBy: string;
    updatedDate: string;
    updatedBy: string;

    liters: number;
    karga: number;
    returnDestination: string; 
    soli: number;
    dagSoli: number;
    areglo: number;
    escort: number;
    shippingLineAgent: string;
    shippingLineFee: number;
    checkerName: string;
    cFee: number;
    tollGate: number;
    manPower: number;
    singitPier2: number;
    remarks: string;
    remarksFee: number;
    allowance: number;
    cashDiesel: number;
    pricePerLiter: number;

    totalCommonExpense: number;
    totalOtherExepense: number;

    // NEW FIELDS - DECEMBER 2022    
    cashDieselEmpty: number;
    pricePerLiterEmpty: number;
    litersEmpty: number;
    xray: number;
    tollGateEmpty: number;
    tripTicketId: string;
    tripTicketGeneratedDate: string;
    isTripTicketPrinted: boolean;

    // NEW FIELDS - APRIL 2024    
    dailyTripTypeId: number;
    tabs: number;
    tabsPenalty: number;
    abonoTabs: boolean;
    abonoTabsPenalty: boolean;
    totalVehicleExpense2024: number;    

    //extra fields for viewing purposes only
    clientId: number;
    clientName: string;
    tripContainerDetailDestination: string;
    tripContainerDetailContainers: string;
    tripContainerDetailSize: string;
    tripBillOfLading: string;
    shippingLine: string
    truck: string;

    driverRate: number;
    helperRate: number;
    tripRate: number;

    abonoManPower: boolean;
    abonoDagSoli: boolean;
    abonoEscort: boolean;

    constructor(){
        this.id = 0;
        this.liters = 0;
        this.karga = 0;
        this.soli = 0;
        this.dagSoli = 0;
        this.areglo = 0;
        this.escort = 0;
        this.shippingLineFee = 0;
        this.cFee = 0;
        this.tollGate = 0;
        this.manPower = 0;
        this.singitPier2 = 0;
        this.remarksFee = 0;
        this.allowance = 0;
        this.cashDiesel = 0;
        this.pricePerLiter = 0;
        this.totalCommonExpense = 0;
        this.totalOtherExepense = 0;

        this.cashDieselEmpty = 0;
        this.pricePerLiterEmpty = 0;
        this.litersEmpty = 0;
        this.xray = 0;
        this.tollGateEmpty = 0;
        this.tripTicketId = '';
        this.isTripTicketPrinted = false;

        this.tripDate = DateHelper.getDateNowString();
        this.dailyTripExpenses = [];

        this.abonoManPower = false;
        this.abonoDagSoli = false;
        this.abonoEscort = false;

        this.dailyTripTypeId = 0;
        this.tabs = 0;
        this.tabsPenalty = 0;
        this.abonoTabs = false;
        this.abonoTabsPenalty = false;
        this.totalVehicleExpense2024 = 0;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/trips/dailyTrip.ts